/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/no-array-for-each */
import '@silevis/reactgrid/styles.css';
import './MonthlyTableView.css';

import { Box, useToast } from '@chakra-ui/react';
import { Column, ReactGrid, Row } from '@silevis/reactgrid';
import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import CustomToast from 'components/CustomToast';
import { BulkUpdateIndicatorDataInputRequestBody } from 'models/requestBody/modifyIndicatorDataInput.interface';
import { getIndicatorDetailTableData, getTableView } from 'redux/IndicatorPageSlice';
import { getSelectedDriver, planPageShow } from 'redux/PlanPageSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import apiService from 'services';
import PlanPermission from 'container/PlanPermission';

import { HeaderCell } from './HeaderCell';
import { NewCell } from './NewCell';
import { YearCell } from './YearColumn';

interface Person {
  name: string;
  props?: any;
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
}

const getColumns = (): Column[] => [
  { columnId: 'Year', width: 60 },
  { columnId: 'Jan', width: 100 },
  { columnId: 'Feb', width: 100 },
  { columnId: 'Mar', width: 100 },
  { columnId: 'Apr', width: 100 },
  { columnId: 'May', width: 100 },
  { columnId: 'Jun', width: 100 },
  { columnId: 'Jul', width: 100 },
  { columnId: 'Aug', width: 100 },
  { columnId: 'Sep', width: 100 },
  { columnId: 'Oct', width: 100 },
  { columnId: 'Nov', width: 100 },
  { columnId: 'Dec', width: 100 },
];

const headerRow: Row = {
  rowId: 'header',
  cells: [
    { type: 'header', text: '' },
    { type: 'header', text: 'Jan' },
    { type: 'header', text: 'Feb' },
    { type: 'header', text: 'Mar' },
    { type: 'header', text: 'Apr' },
    { type: 'header', text: 'May' },
    { type: 'header', text: 'Jun' },
    { type: 'header', text: 'Jul' },
    { type: 'header', text: 'Aug' },
    { type: 'header', text: 'Sep' },
    { type: 'header', text: 'Oct' },
    { type: 'header', text: 'Nov' },
    { type: 'header', text: 'Dec' },
  ],
};

const getRows: any = (people: any, indicator: any, isPercentage: boolean) => {
  return [
    headerRow,
    ...people.map((person: any, index: number) => ({
      rowId: person.Year,
      height: 40,
      cells: [
        {
          type: 'yearCell',
          text: person.Year || '',
          nonEditable: true,
        },
        {
          type: 'newCell',
          className: `${index === 0 && 'border-top'} ${
            people?.length - 1 === index && 'border-left'
          }`,
          placeholder: 'xxx',
          text: person?.Jan?.value ? `${person?.Jan?.value}` : '0',
          nonEditable: !person?.Jan?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Feb?.value ? `${person?.Feb?.value}` : '0',
          nonEditable: !person?.Feb?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Mar?.value ? `${person?.Mar?.value}` : '0',
          nonEditable: !person?.Mar?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Apr?.value ? `${person?.Apr?.value}` : '0',
          nonEditable: !person?.Apr?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.May?.value ? `${person?.May?.value}` : '0',
          nonEditable: !person?.May?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Jun?.value ? `${person?.Jun?.value}` : '0',
          nonEditable: !person?.Jun?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Jul?.value ? `${person?.Jul?.value}` : '0',
          nonEditable: !person?.Jul?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Aug?.value ? `${person?.Aug?.value}` : '0',
          nonEditable: !person?.Aug?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Sep?.value ? `${person?.Sep?.value}` : '0',
          nonEditable: !person?.Sep?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Oct?.value ? `${person?.Oct?.value}` : '0',
          nonEditable: !person?.Oct?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          text: person?.Nov?.value ? `${person?.Nov?.value}` : '0',
          nonEditable: !person?.Nov?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
        {
          type: 'newCell',
          className: `${index === 0 && 'border-right'} ${
            people?.length - 1 === index && 'border-bottom'
          }`,
          text: person?.Dec?.value ? `${person?.Dec?.value}` : '0',
          nonEditable: !person?.Dec?.isEnable,
          format: indicator?.data_format_properties,
          isPercentage,
        },
      ],
    })),
  ];
};

export interface Properties {
  refetchRequest: () => void;
  planPermission: boolean;
  itemName?: any | string;
}

const MonthlyViewTable = ({ itemName, planPermission, refetchRequest }: Properties) => {
  const indicator: any = useSelector(getIndicatorDetailTableData);
  const tab = useSelector(getTableView);
  const show = useSelector(planPageShow);
  const [people, setPeople] = React.useState<Person[]>([]);
  const isPercentage = indicator?.data_format.toLowerCase() === 'percentage';
  const toast = useToast();
  const currentDriver = useSelector(getSelectedDriver);
  const containerReference = useRef<HTMLDivElement>(null);
  const baseScenario = useSelector(getBaseScenario);
  const getPeople = (): any => {
    if (itemName) {
      const monthlyData = indicator?.monthly_data?.find((el: any) => el.item === itemName);
      if (monthlyData) {
        const data: any = [];
        Object.keys(monthlyData?.years).forEach((key: string) => {
          const obj: any = {};
          obj.Year = key;
          monthlyData?.years[key]?.forEach((month: any) => {
            obj[month.month] = month;
          });
          data.push(obj);
        });
        return data;
      }
      return [];
    }

    const monthlyData = indicator?.monthly_data[0];
    if (monthlyData) {
      const data: any = [];
      Object.keys(monthlyData?.years).forEach((key: string) => {
        const obj: any = {};
        obj.Year = key;
        monthlyData?.years[key]?.forEach((month: any) => {
          obj[month.month] = month;
        });
        data.push(obj);
      });
      return data;
    }
    return [];
  };

  const columns = useMemo(() => getColumns(), []);

  const getPeopleData = async () => {
    const data = await getPeople();

    setPeople(data);
  };

  useEffect(() => {
    getPeopleData();
  }, [indicator, tab, show]);
  const delay = 400;
  let timer: any = null;

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      getPeopleData();
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [show]);

  const rows = useMemo(
    () => getRows(people, indicator, isPercentage),
    [people, indicator, isPercentage],
  );

  const handleChanges = (changes: any) => {
    const dataInputs: any = [];
    changes.forEach((change: any) => {
      const object = {
        [currentDriver.time_dim]: `${change.columnId}-${change.rowId[2]}${change.rowId[3]}`,
        [currentDriver.dimensions[0]]: itemName,
        value: change.newCell.text,
      };
      dataInputs.push(object);
    });

    const requestBody: BulkUpdateIndicatorDataInputRequestBody = {
      request_body: {
        indicator_id: indicator?.id,
        item_name: itemName || null,
        data_inputs: dataInputs,
        scenario_id: baseScenario?.id,
      },
    };

    apiService
      .bulk_update_indicator_data(requestBody)
      .then((res: any) => {
        refetchRequest();
        toast({
          duration: 2500,
          render: () => <CustomToast title={res?.data?.message} status='success' />,
        });
      })
      .catch((error: any) => {
        toast({
          duration: 2500,
          render: () => (
            <CustomToast
              title={error?.response?.data?.message || 'Something went wrong..'}
              status='error'
            />
          ),
        });
        return null;
      });
  };

  return (
    <Box
      className='monthly-tableview-container'
      ref={containerReference}
      cursor={planPermission ? 'not-allowed' : 'pointer'}
      // overflow={rows.length > 6 ? 'auto' : 'initial'}
    >
      {rows?.length && columns?.length && (
        <ReactGrid
          enableFillHandle
          enableRangeSelection
          stickyTopRows={1}
          rows={rows}
          enableColumnSelection
          columns={columns}
          onCellsChanged={planPermission ? undefined : handleChanges}
          customCellTemplates={{
            newCell: new NewCell(),
            header: new HeaderCell(),
            yearCell: new YearCell(),
          }}
        />
      )}
    </Box>
  );
};

export default PlanPermission(MonthlyViewTable);
